import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/home/contact/img_home_contact_img_left.png'
import _imports_1 from '@/assets/home/contact/img_home_contact_img_right.png'


const _withScopeId = n => (_pushScopeId("data-v-44d9c24c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "h-ct-root" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "h-ct-img-left"
}, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  class: "h-ct-img-right hidden-md-and-down"
}, null, -1))
const _hoisted_4 = { class: "h-ct-item" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "h-ct-title hidden-md-and-down" }, " 荧辉科技，为您护航 ", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "h-ct-title-phone hidden-md-and-up" }, " 荧辉科技，为您护航 ", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "h-ct-text margin-top-20 hidden-md-and-down" }, " 专家团队，为您快速维护信用问题 ", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "h-ct-text-phone margin-top-20 hidden-md-and-up" }, " 专家团队，为您快速维护信用问题 ", -1))
const _hoisted_9 = { class: "h-ct-btn-div margin-top-30" }

import {AppConfig} from "@/config";
import {isShowQrCodeDialog} from "@/views/data/CommonData";


export default /*#__PURE__*/_defineComponent({
  __name: 'HomeContact',
  setup(__props) {

const onBtnClick = () => {
  isShowQrCodeDialog.value = true
}

return (_ctx: any,_cache: any) => {
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createVNode(_component_el_row, {
      class: "width-100",
      justify: "center"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_col, {
          md: 10,
          span: _unref(AppConfig).span
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_4, [
              _hoisted_5,
              _hoisted_6,
              _hoisted_7,
              _hoisted_8,
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("span", {
                  class: "h-ct-btn-left margin-right-10",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (onBtnClick()))
                }, "免费咨询"),
                _createElementVNode("span", {
                  class: "h-ct-btn-right margin-left-10",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (onBtnClick()))
                }, "联系我们")
              ])
            ])
          ]),
          _: 1
        }, 8, ["span"])
      ]),
      _: 1
    })
  ]))
}
}

})